import apis from './apis';

/**
 * Living Documents (Epic B, item 5) - review ↔ playbook lineage.
 *
 * A review session is "behind" once the playbook it ran against gains or changes
 * clauses. These helpers let the review view show a passive "playbook updated"
 * banner and trigger a SCOPED re-review of only the added/changed clauses across
 * the session's existing documents (never a full re-review).
 */

export interface ReviewPlaybookStatus {
  linked: boolean;
  status: 'up_to_date' | 'behind' | 'unversioned' | 'unlinked' | 'unknown';
  from_version?: number | null;
  to_version?: number | null;
  /** How many clause rules were added/changed since this session last ran. */
  changed_clause_count?: number;
}

/** Passive check - never queues anything. */
export async function getReviewPlaybookStatus(sessionUuid: string): Promise<ReviewPlaybookStatus> {
  const res = await apis.get(`/reviews/${sessionUuid}/playbook-status`);
  return (res.data?.data ?? res.data) as ReviewPlaybookStatus;
}

export interface RerunReviewResult {
  status: 'processing' | 'up_to_date';
  reason?: string;
  session_uuid?: string;
  playbook_uuid?: string;
  clauses_rerun?: number;
  document_count?: number;
  to_version?: number | null;
  correlation_id?: string;
  pubsub?: { hub?: string; group: string; correlation_id: string };
}

/** Re-review only the clauses added/changed since this session last ran. */
export async function rerunReviewFromPlaybook(sessionUuid: string): Promise<RerunReviewResult> {
  const res = await apis.post(`/reviews/${sessionUuid}/rerun-from-playbook`, {});
  return (res.data?.data ?? res.data) as RerunReviewResult;
}
